"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bankTransfersRepository = void 0;
exports.fetchPendingTransfers = fetchPendingTransfers;
exports.fetchDuplicates = fetchDuplicates;
exports.fetchWadiumMatches = fetchWadiumMatches;
exports.uploadBankStatement = uploadBankStatement;
exports.commitStatement = commitStatement;
exports.fetchAllocations = fetchAllocations;
exports.createAllocation = createAllocation;
exports.deleteAllocation = deleteAllocation;
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const RepositoryReact_1 = __importDefault(require("../../React/RepositoryReact"));
async function apiFetch(path, init) {
    const res = await fetch(`${MainSetupReact_1.default.serverUrl}${path}`, {
        credentials: 'include',
        ...init,
    });
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error ?? body.errorMessage ?? `HTTP ${res.status}`);
    }
    return res.json();
}
exports.bankTransfersRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: 'bank-transfers',
        addNewRoute: 'bank-transfers',
        editRoute: 'bank-transfers',
        deleteRoute: 'bank-transfers',
    },
    name: 'bankTransfers',
});
async function fetchPendingTransfers() {
    return apiFetch('bank-transfers/pending');
}
async function fetchDuplicates() {
    return apiFetch('bank-transfers/duplicates');
}
async function fetchWadiumMatches() {
    return apiFetch('bank-transfers/wadium-matches');
}
async function uploadBankStatement(file) {
    const form = new FormData();
    form.append('file', file);
    return apiFetch('bank-statements', {
        method: 'POST',
        body: form,
    });
}
async function commitStatement(statementId) {
    return apiFetch(`bank-statements/${statementId}/commit`, { method: 'POST' });
}
async function fetchAllocations(transferId) {
    return apiFetch(`bank-transfers/${transferId}/allocations`);
}
async function createAllocation(transferId, data) {
    return apiFetch(`bank-transfers/${transferId}/allocations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
}
async function deleteAllocation(transferId, allocId) {
    await apiFetch(`bank-transfers/${transferId}/allocations/${allocId}`, { method: 'DELETE' });
}
